module.exports = __webpack_public_path__ + "static/media/EICHERMOT_F1.d3943a62.txt";